// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base_loader {
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.l_small {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  width: 20px;
  height: 20px;
}

.l_medium {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
}

.l_large {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  width: 80px;
  height: 80px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/component/utility/Loader/Loader.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,kCAAA;AACD;;AAEA;EACC,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEA;EACC,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEA;EACC,0BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEA;EACC;IACC,uBAAA;EACA;EACD;IACC,yBAAA;EACA;AACF","sourcesContent":[".base_loader {\n\tposition: absolute;\n\tz-index: 1;\n\tborder-radius: 50%;\n\tanimation: spin 2s linear infinite;\n}\n\n.l_small {\n\tborder: 3px solid #f3f3f3;\n\tborder-top: 3px solid #3498db;\n\twidth: 20px;\n\theight: 20px;\n}\n\n.l_medium {\n\tborder: 4px solid #f3f3f3;\n\tborder-top: 4px solid #3498db;\n\twidth: 40px;\n\theight: 40px;\n}\n\n.l_large {\n\tborder: 16px solid #f3f3f3;\n\tborder-top: 16px solid #3498db;\n\twidth: 80px;\n\theight: 80px;\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
